export default "__VITE_ASSET__DPdTkYky__"